import type { SVGProps } from "react";

export function Twitter(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53A4.48 4.48 0 0 0 16.5 3a4.5 4.5 0 0 0-4.5 4.5c0 .35.04.7.12 1.03A12.94 12.94 0 0 1 3 4.1a4.5 4.5 0 0 0 1.39 6.01A4.4 4.4 0 0 1 2.8 9.5v.06A4.5 4.5 0 0 0 6.4 14a4.4 4.4 0 0 1-1.18.16c-.29 0-.57-.03-.84-.08A4.5 4.5 0 0 0 8.5 17a9 9 0 0 1-5.58 1.92A9.4 9.4 0 0 1 2 19a12.7 12.7 0 0 0 6.88 2.02c8.26 0 12.78-6.84 12.78-12.78 0-.2 0-.41-.02-.61A9.2 9.2 0 0 0 23 3z" />
    </svg>
  );
}
